// extracted by mini-css-extract-plugin
module.exports = {"article-nav":"ArticleNav_article-nav___wlOZ","article-nav-list":"ArticleNav_article-nav-list__rZ70v","is-active":"ArticleNav_is-active__Ibm1e"};